const state = {
    activity_list:''
};

const mutations = {
    set_activity_list(state,val){
        state.activity_list = val;
    }
};

const actions = {

};

const getters = {

};

export default {
    state,
    mutations,
    actions,
    getters
}
